// extracted by mini-css-extract-plugin
export default {"toolbar":"WXST0E"};